import {FC, useCallback} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {IAchievement} from "modules/reducers";
import {useWindowSize} from "modules/utils";
import {showBadgeModal} from "modules/actions";
import {Badge, PureButton} from "components";

const Wrapper = styled(PureButton)`
	display: flex;
	flex-direction: column;
	align-items: center;
	color: ${({theme}) => theme.color.tertiary};
`;

const BadgeName = styled.div`
	margin-top: 16px;
	font-family: "Khand", sans-serif;
	font-weight: 700;
	font-size: 14px;
	line-height: 130%;
	word-break: break-word;

	@media (min-width: 769px) {
		font-size: 20px;
	}
`;

const mobileSize = 78;
const desktopSize = 82;
const mobileWidth = 768;

const getSize = (width: number): string => {
	const isMobile = width <= mobileWidth;

	if (isMobile) {
		return `${mobileSize}px`;
	}

	return `${desktopSize}px`;
};

export const BadgesListItem: FC<IAchievement> = (achievement) => {
	const dispatch = useDispatch();
	const {t} = useTranslation();
	const {width} = useWindowSize();

	const clickHandler = useCallback(() => {
		dispatch(showBadgeModal(achievement.name));
	}, [dispatch, achievement.name]);

	return (
		<Wrapper onClick={clickHandler}>
			<Badge achievement={achievement} height={getSize(width)} width={getSize(width)} />

			<BadgeName>{t(`badges.name.${achievement.name}`)}</BadgeName>
		</Wrapper>
	);
};
